import { MenuItem, Select, TextField } from "@mui/material";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const PaginationComponent = ({ offset, setOffset, limit, setLimit, total }) => {
  return (
    <div className="w-full flex justify-between mt-4 text-md">
      <div className="flex gap-2 items-center w-full">
        <p>Baris per halaman</p>
        <Select
          value={limit}
          onChange={(e) => {
            setLimit(e.target.value);
            setOffset(1);
          }}
          sx={{
            backgroundColor: "#fff",
            height: 38,
            borderRadius: "8px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
            },
            fontSize: "13px",
            fontFamily: '"Montserrat", sans-serif',
          }}
          inputProps={{
            style: {
              paddingTop: 8,
              paddingBottom: 8,
              fontSize: "13px",
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                borderRadius: "8px",
              },
            },
          }}
        >
          <MenuItem
            sx={{ fontSize: 13, fontFamily: '"Montserrat", sans-serif' }}
            value={10}
          >
            10
          </MenuItem>
          <MenuItem
            sx={{ fontSize: 13, fontFamily: '"Montserrat", sans-serif' }}
            value={25}
          >
            25
          </MenuItem>
          <MenuItem
            sx={{ fontSize: 13, fontFamily: '"Montserrat", sans-serif' }}
            value={50}
          >
            50
          </MenuItem>
        </Select>

        <p className="italic">
          Menampilkan {(offset - 1) * limit + 1}-
          {total < offset * limit ? total : offset * limit} dari {total} data
        </p>
      </div>

      <div className="flex gap-2 items-center text-right w-full justify-end">
        <TextField
          sx={{
            backgroundColor: "#fff",
            width: "48px",
            fontSize: "13px",
            "& ::placeholder": { fontSize: "13px" },
            borderRadius: "8px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
            },
            fontFamily: '"Montserrat", sans-serif',
          }}
          inputProps={{
            style: {
              paddingTop: 9,
              paddingBottom: 9,
              fontSize: "13px",
              fontFamily: '"Montserrat", sans-serif',
            },
          }}
          placeholder="0"
          value={offset === 0 ? "" : offset}
          onChange={(e) => {
            const newValue = e.target.value;
            if (!isNaN(Number(newValue))) {
              setOffset(newValue === "" ? 0 : Number(newValue));
            }
          }}
          onBlur={() => {
            if (offset === 0) {
              setOffset(1);
            }
          }}
        />
        <p>of {Math.ceil(total / limit)}</p>
        <button
          type="button"
          disabled={offset === 1}
          className="rounded-lg p-2 border-2 w-[36px] h-[36px] border-gray-300 cursor-pointer hover:bg-gray-100 disabled:bg-gray-300 disabled:cursor-default disabled:text-white"
          onClick={() => setOffset(offset - 1)}
        >
          <FaChevronLeft className="w-full h-full" />
        </button>

        <button
          type="button"
          disabled={offset === Math.ceil(total / limit)}
          className="rounded-lg p-2 border-2 w-[36px] h-[36px] border-gray-300 cursor-pointer hover:bg-gray-100 disabled:bg-gray-300 disabled:cursor-default disabled:text-white"
          onClick={() => setOffset(offset + 1)}
        >
          <FaChevronRight className="w-full h-full" />
        </button>
      </div>
    </div>
  );
};

export default PaginationComponent;
